export const RoutesLink = {
  landingPage: "/",
  Home: "/home",
  AboutUs: "/about-us",
  CreditTools: "/credit-tools",
  myAccount: "/my-account",
  LendingPartners: "/lending-partners",
  Support: "/support",
  Blogs: "/blogs",
  LoanProducts: "/loan-products",
  Contact: "/contact",
  personalInformation: "/personal-information",
  myLoans: "/my-loans",
  documents: "/documents",
  dashboard: "/dashboard",
}

export const DashboardRoutesLinks = {
  dashboard: "/dashboard",
  personalInformation: "/personalInformation",
  ekyc: "/e-kyc",
  bankDetails: "/bankDetails",
  employmentDetails: "/employmentDetails",
  myAccount: '/my-account',
  documents: '/documents',
  myLoans: "/my-loans",
  support: "#",
}
